import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IframRedirectionsService {

  private permissionEvent = new BehaviorSubject<boolean>(false);
  permissionEvent$ = this.permissionEvent.asObservable();

  constructor(
    private _router: Router
  ) { }

  panelTabs: any = [
    { name: 'Overview', value: 'OVERVIEW', redirectTo: '/admin/passbook/overview', status: true },
    { name: 'Plan Enrollments', value: 'SCHEME_ENROLLMENT', redirectTo: '/admin/passbook/enrollments', pageNo: 1, status: false },
    { name: 'Customers', value: 'CUSTOMERS', redirectTo: '/admin/passbook/customers', pageNo: 1, status: false },
    { name: 'Due Payments', value: 'DUE_PAYMENTS', redirectTo: '/admin/passbook/due-payments', pageNo: 1, status: false },
    { name: 'Redemption', value: 'REDEMPTION', redirectTo: '/admin/passbook/redemption', pageNo: 1, status: false },
    { name: 'QR Scans', value: 'QR_LISTING', redirectTo: '/admin/passbook/qr-listing', pageNo: 1, status: false },
    { name: 'Transactions', value: 'TRANSACTION', redirectTo: '/admin/passbook/transction-listing', pageNo: 1, status: false },
    { name: 'Incentives', value: 'INCENTIVES', redirectTo: '/admin/passbook/incentives', pageNo: 1, status: false },
    { name: 'Staff', value: 'STAFF', redirectTo: '/admin/passbook/staff', pageNo: 1, status: false }
  ];

  private permissionKeyMap: any = {
    OVERVIEW: 'DASHBOARD',
    SCHEME_ENROLLMENT: 'SCHEME ENROLLMENTS',
    CUSTOMERS: 'CUSTOMERS',
    DUE_PAYMENTS: 'DUE PAYMENTS',
    REDEMPTION: 'REDEMPTIONS',
    QR_LISTING: 'SCANS',
    TRANSACTION: 'TRANSACTIONS',
    INCENTIVES: 'INCENTIVES',
    STAFF: 'STAFF',
    GOLD_HISTORY: 'GOLD PRICES',
    SETTINGS: 'PASSBOOK-CONFIG'
  };


  getFirstAllowedTabUrl(): string | null {

  const permissionString = localStorage.getItem('permission');
  if (!permissionString) return null;

  const permissionObj = JSON.parse(permissionString);

  // ✅ 1. If admin → always allow overview
  if (permissionObj.admin === true) {
    return '/admin/passbook/overview';
  }

  const cmisPermission = permissionObj?.cmisPermission?.PASSBOOK;

  // ❌ If PASSBOOK not present → no access
  if (!cmisPermission) return null;

  // ✅ Loop in your defined order
  for (let tab of this.panelTabs) {

    const permissionKey = this.permissionKeyMap[tab.value];

    if (!permissionKey) continue;

    const allowedActions = cmisPermission[permissionKey];

    // ✅ At least one permission exists
    if (Array.isArray(allowedActions) && allowedActions.length > 0) {
      return tab.redirectTo;
    }
  }

  // ❌ No tab allowed
  return null;
}
}
